import {useContext, useState} from 'react';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Button,
    ModalBody,
    Form,
    Label,
    Input,
    Modal, ModalHeader, FormGroup, FormFeedback
} from "reactstrap";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import Loader from "../../components/Loader";
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import AuthContext from "../../context/AuthContext";
import {
    changeProductInventoryTrackingStatus,
    changeProductStatus,
    editProduct,
    getMerchantKYCIndiaInfo,
    productStockUpdate
} from "../../api/api";
import ProductStockModal from "./ProductStockModal";



function ActionButton(props) {
    const {refreshToken} = useContext(AuthContext)
    const { data: kycData } = useQuery({
        queryKey: ['merchant-kyc-india'],
        queryFn: getMerchantKYCIndiaInfo,
    });
    const canChargeGst = kycData?.results?.[0]?.can_charge_gst ?? true;
    const [actionButtonDropdownOpen, setActionButtonDropdownOpen] = useState(false);
    const toggleActionButtonDropdown = () => {
        setActionButtonDropdownOpen(prevState => {
            const newDropdownState = !prevState;
            document.querySelector('.table-responsive').classList.toggle('dropdown-open', newDropdownState);
            return newDropdownState;
        });
    }
    const [productUpdateToggle, setProductUpdateToggle] = useState(false);
    const toggleUpdateModal = () => {
        setProductUpdateToggle(prevState => {
            const newState = !prevState;
            if (!newState) resetFormFields();
            return newState;
        });
    };
    const [productStockUpdateToggle, setProductStockUpdateToggle] = useState(false);
    const toggleStockUpdateModal = () =>
        setProductStockUpdateToggle((prevState) => !prevState);
    // const [productSettingsToggle, setProductSettingsToggle] = useState(false);
    // const toggleProductSettingsModal = () =>
    //     setProductSettingsToggle((prevState) => !prevState);

    const [productName, setProductName] = useState(props.product.name);
    const [productPrice, setProductPrice] = useState(props.product.price);
    const [productUPC, setProductUPC] = useState(props.product.upc);
    const [productHSNSAC, setProductHSNSAC] = useState(props.product.hsn_sac);
    const [productUnitOfMeasure, setProductUnitOfMeasure] = useState(props.product.unit_of_measure);
    const [productTaxType, setProductTaxType] = useState(props.product.tax_type);
    const [productTaxPercentage, setProductTaxPercentage] = useState(props.product.tax_percentage);
    const [productDescription, setProductDescription] = useState(props.product.description);
    const [productImage, setProductImage] = useState('');
    const [productStockTransactionName, setProductStockTransactionName] = useState('');
    const [productStock, setProductStock] = useState('');
    const [stockTransactionType, setStockTransactionType] = useState('CR');
    const [advancedOptions, setAdvancedOptions] = useState(false);
    const [stockHistoryModal, setStockHistoryModal] = useState(false);
    const stockHistoryModaltoggle = () => setStockHistoryModal(!stockHistoryModal);

    const queryClient = useQueryClient()

    const resetFormFields = () => {
        setProductName(props.product.name);
    };

    const changeProductStatusMutation = useMutation({
        mutationFn: changeProductStatus,
        onSuccess: (data, variables) =>{
            queryClient.invalidateQueries(['products'])
            toast.success('Product Status Changed!')
        },
        // onError: error => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, changeProductStatusMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const changeProductInventoryTrackingStatusMutation = useMutation({
        mutationFn: changeProductInventoryTrackingStatus,
        onSuccess: () =>{
            queryClient.invalidateQueries(['products'])
            toast.success('Product Inventory Status Changed!')
        },
        // onError: error => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, changeProductInventoryTrackingStatusMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })


    const editProductMutation = useMutation({
        mutationFn: editProduct,
        onSuccess: (data, variables) =>{
            toggleUpdateModal()
            queryClient.invalidateQueries(['products'])
            toast.success('Product updated!')
        },
        // onError: error => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // }
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, editProductMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })

    const productStockUpdateMutation = useMutation({
        mutationFn: productStockUpdate,
        onSuccess: (data, variables) =>{
            toggleStockUpdateModal()
            setProductStockTransactionName('')
            setProductStock('')
            setStockTransactionType('CR')
            queryClient.invalidateQueries(['products'])
            toast.success('Product Stock updated!')
        },
        // onError: err => {
        //     toast.error(`An error occurred! ${err?.response?.data?.detail}`)
        // }
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, productStockUpdateMutation, variables)
            if(err.response.status !== 401){
                toast.error(`An error occurred! ${err?.response?.data?.detail}`)
            }
        }
    })


    const handleChangeProductStatus = async (product) => {
        let productStatus = {
            status: product.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
        };
        changeProductStatusMutation.mutate({
            productStatus: productStatus, productId: product.id
        })
    }

    const handleChangeProductInventoryTrackingStatus = async (product) => {
        let productInventoryTrackingStatus = {
            is_inventory_tracking_enabled: product.is_inventory_tracking_enabled === true ? false : true,
        };
        changeProductInventoryTrackingStatusMutation.mutate({
            productInventoryTrackingStatus: productInventoryTrackingStatus, productId: product.id
        })
    }

    const handleEditProduct = async (product, e) => {
        e?.preventDefault();
        const formData = new FormData();
        formData.append("name", productName);
        formData.append("price", productPrice);
        formData.append("description", productDescription);
        formData.append("upc", productUPC);
        formData.append("hsn_sac", productHSNSAC);
        formData.append("unit_of_measure", productUnitOfMeasure);
        formData.append("tax_type", productTaxType);
        formData.append("tax_percentage", productTaxPercentage);
        if (productImage) formData.append("image", productImage);

        editProductMutation.mutate({
            formData: formData, productId: product.id
        }, )
    };


    const handleProductStockUpdate = async (product, e) => {
        e?.preventDefault();
        const formData = new FormData();
        if (productStockTransactionName) formData.append("name", productStockTransactionName);
        formData.append("product", product.id);
        formData.append("stock", productStock);
        formData.append("type", stockTransactionType);

        productStockUpdateMutation.mutate({
            formData: formData, productId: product.id
        })
    }

    return (
        <td className="text-center">
            <Dropdown
                nav
                isOpen={actionButtonDropdownOpen}
                toggle={toggleActionButtonDropdown}
                className="btn-group"
            >
                <DropdownToggle
                    caret
                    className="arrow-none btn-sm"
                >
                    <i className="mdi mdi-dots-horizontal"/>
                </DropdownToggle>
                <DropdownMenu end className="dropdown-menu-right profile-dropdown">
                    <DropdownItem
                        className="dropdown-item"
                        onClick={toggleUpdateModal}
                    >
                        <i className="mdi mdi-pencil mr-2 text-muted font-18 vertical-middle"/>
                        <span>Edit Product</span>
                    </DropdownItem>

                    <DropdownItem
                        className="dropdown-item"
                        onClick={() => handleChangeProductStatus(props.product)}
                    >
                        <i className="mdi mdi-cancel mr-2 text-muted font-18 vertical-middle"/>
                        <span>
                                {props.product.status === "ACTIVE"
                                    ? "Make INACTIVE"
                                    : "Make ACTIVE"}
                            </span>
                    </DropdownItem>

                    <DropdownItem
                        className="dropdown-item"
                        onClick={() => handleChangeProductInventoryTrackingStatus(props.product)}
                    >
                        <i className="mdi mdi-stocking mr-2 text-muted font-18 vertical-middle"/>
                        <span>
                                {props.product.is_inventory_tracking_enabled === true
                                    ? "Disable Inventory Tracking"
                                    : "Enable Inventory Tracking"}
                            </span>
                    </DropdownItem>

                    {props.product.is_inventory_tracking_enabled && (
                        <DropdownItem
                            className="dropdown-item"
                            onClick={toggleStockUpdateModal}
                        >
                            <i className="mdi mdi-update mr-2 text-muted font-18 vertical-middle"/>
                            <span>Update Stock</span>
                        </DropdownItem>
                    )}
                    {props.product.is_inventory_tracking_enabled && (
                        <DropdownItem
                            className="dropdown-item"
                            onClick={stockHistoryModaltoggle}
                        >
                            <i className="fe-box mr-2 text-muted font-18 vertical-middle"/>
                            <span>View Stock</span>
                        </DropdownItem>
                    )}


                    {/*<DropdownItem*/}
                    {/*    className="dropdown-item"*/}
                    {/*    onClick={toggleProductSettingsModal}*/}
                    {/*>*/}
                    {/*    <i className="mdi mdi-settings mr-2 text-muted font-18 vertical-middle"/>*/}
                    {/*    <span>Product Settings</span>*/}
                    {/*</DropdownItem>*/}
                </DropdownMenu>
            </Dropdown>
            <ProductStockModal product={props.product} modal={stockHistoryModal} modalToggle={stockHistoryModaltoggle}/>

            <Modal
                isOpen={productUpdateToggle}
                toggle={toggleUpdateModal}
                backdrop="static"
                keyboard={false}
                className=""
            >
                <ModalHeader toggle={toggleUpdateModal} close={
                    <button className="close" onClick={toggleUpdateModal}>
                        &times;
                    </button>
                }>
                    Update Product: {props.product.name}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={(e) => handleEditProduct(props.product, e)}>
                        <FormGroup>
                            <Label for="Name">Name<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="name"
                                id="name"
                                placeholder="Product name"
                                defaultValue={props.product.name}
                                onChange={(e) =>
                                    setProductName(e.target.value)
                                }
                                invalid={
                                    editProductMutation.isError &&
                                    editProductMutation.error.response.data.name
                                }
                            />
                            {editProductMutation.isError && editProductMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {editProductMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="Price">Price<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                min="1"
                                step="any"
                                name="Price"
                                id="price"
                                placeholder="Product Price"
                                defaultValue={props.product.price}
                                onChange={(e) =>
                                    setProductPrice(e.target.value)
                                }
                                invalid={
                                    editProductMutation.isError &&
                                    editProductMutation.error.response.data.price
                                }
                            />
                            {editProductMutation.isError && editProductMutation.error.response.data.price && (
                                <FormFeedback invalid>
                                    {editProductMutation.error.response.data.price}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup className="form-group mb-3">
                            <div className="custom-control custom-checkbox">
                                <Input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="checkbox-advanced-options"
                                    checked={advancedOptions}
                                    onChange={() => setAdvancedOptions(!advancedOptions)}
                                />
                                <Label
                                    className="custom-control-label"
                                    for="checkbox-advanced-options"                                    >
                                    Advanced Options
                                </Label>
                            </div>
                        </FormGroup>
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="description">Description</Label>
                                <Input
                                    type="textarea"
                                    name="Description"
                                    placeholder="Product Description"
                                    id="Description"
                                    defaultValue={props.product.description}
                                    onChange={(e) =>
                                        setProductDescription(e.target.value)
                                    }
                                    invalid={
                                        editProductMutation.isError &&
                                        editProductMutation.error.response.data.description
                                    }
                                />
                                {editProductMutation.isError && editProductMutation.error.response.data.description && (
                                    <FormFeedback invalid>
                                        {editProductMutation.error.response.data.description}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="upc">UPC</Label>
                                <Input
                                    type="text"
                                    name="upc"
                                    id="upc"
                                    placeholder="Product UPC"
                                    defaultValue={props.product.upc}
                                    onChange={(e) =>
                                        setProductUPC(e.target.value)
                                    }
                                    invalid={
                                        editProductMutation.isError &&
                                        editProductMutation.error.response.data.upc
                                    }
                                />
                                {editProductMutation.isError && editProductMutation.error.response.data.upc && (
                                    <FormFeedback invalid>
                                        {editProductMutation.error.response.data.upc}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && canChargeGst && (
                            <FormGroup>
                                <Label for="hsn_sac">HSN/SAC</Label>
                                <Input
                                    type="text"
                                    name="hsn_sac"
                                    id="hsn_sac"
                                    placeholder="HSN/SAC"
                                    defaultValue={props.product.hsn_sac}
                                    onChange={(e) =>
                                        setProductHSNSAC(e.target.value)
                                    }
                                    invalid={
                                        editProductMutation.isError &&
                                        editProductMutation.error.response.data.hsn_sac
                                    }
                                />
                                {editProductMutation.isError && editProductMutation.error.response.data.hsn_sac && (
                                    <FormFeedback invalid>
                                        {editProductMutation.error.response.data.hsn_sac}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions&& (
                            <FormGroup>
                                <Label for="unit_of_measure">Unit of Measure</Label>
                                <Input
                                    type="text"
                                    name="unit_of_measure"
                                    id="unit_of_measure"
                                    placeholder="Unit of Measure"
                                    defaultValue={props.product.unit_of_measure}
                                    onChange={(e) =>
                                        setProductUnitOfMeasure(e.target.value)
                                    }
                                    invalid={
                                        editProductMutation.isError &&
                                        editProductMutation.error.response.data.unit_of_measure
                                    }
                                />
                                {editProductMutation.isError && editProductMutation.error.response.data.unit_of_measure && (
                                    <FormFeedback invalid>
                                        {editProductMutation.error.response.data.unit_of_measure}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && canChargeGst && (
                            <FormGroup>
                                <Label for="tax_type">Tax Type</Label>
                                <Input
                                    type="select"
                                    id="inputState"
                                    className="form-control mb-2"
                                    defaultValue={props.product.tax_type}
                                    onChange={(e) => setProductTaxType(e.target.value)}
                                >
                                    <option value="">--</option>
                                    <option value={"TAX-INCLUSIVE"}>Tax Inclusive</option>
                                    <option value={"TAX-EXCLUSIVE"}>Tax Exclusive</option>

                                invalid={
                                editProductMutation.isError &&
                                editProductMutation.error.response.data.tax_type
                            }
                                </Input>
                                {editProductMutation.isError && editProductMutation.error.response.data.tax_type && (
                                    <FormFeedback invalid>
                                        {editProductMutation.error.response.data.tax_type}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && canChargeGst && (
                            <FormGroup>
                                <Label for="tax_percentage">Tax Percentage</Label>
                                <Input
                                    type="text"
                                    name="tax_percentage"
                                    id="tax_percentage"
                                    placeholder="Product Tax Percentage"
                                    defaultValue={props.product.tax_percentage}
                                    onChange={(e) =>
                                        setProductTaxPercentage(e.target.value)
                                    }
                                    invalid={
                                        editProductMutation.isError &&
                                        editProductMutation.error.response.data.tax_percentage
                                    }
                                />
                                {editProductMutation.isError && editProductMutation.error.response.data.tax_percentage && (
                                    <FormFeedback invalid>
                                        {editProductMutation.error.response.data.tax_percentage}
                                    </FormFeedback>
                                )}
                            </FormGroup>
                        )}
                        {advancedOptions && !canChargeGst && (
                            <div className="alert alert-info mb-3">
                                <small>GST tax fields are disabled because your business is not registered as a regular GST dealer.</small>
                            </div>
                        )}
                        <FormGroup>
                            <Label for="file">Image</Label>
                            <Input
                                type="file"
                                name="file"
                                id="file"
                                // value={props.product.image}
                                onChange={(e) =>
                                    setProductImage(e.target.files[0])
                                }
                                invalid={
                                    editProductMutation.isError &&
                                    editProductMutation.error.response.data.image
                                }
                            />
                            {/*<FormText color="muted">*/}
                            {/*    {props.product.image}*/}
                            {/*</FormText>*/}
                            {editProductMutation.isError && editProductMutation.error.response.data.image && (
                                <FormFeedback invalid>
                                    {editProductMutation.error.response.data.image}
                                </FormFeedback>
                            )}
                        </FormGroup>

                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={editProductMutation.isLoading}
                        >
                            {editProductMutation.isLoading? <><Loader size={'small'}/> Updating Product...</>: `Update Product`}

                        </Button>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal
                isOpen={productStockUpdateToggle}
                toggle={toggleStockUpdateModal}
            >
                <ModalHeader toggle={toggleStockUpdateModal} close={
                    <button className="close" onClick={toggleStockUpdateModal}>
                        &times;
                    </button>
                }>
                    Update Product Stock: {props.product.name}
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={(e) => handleProductStockUpdate(props.product, e)}>
                        <FormGroup>
                            <Label for="Name">Name</Label>
                            <Input
                                type="text"
                                name="stockTransactionname"
                                id="stockTransactionname"
                                placeholder="Stock Transaction Name"
                                // defaultValue={props.product.name}
                                onChange={(e) =>
                                    setProductStockTransactionName(e.target.value)
                                }
                                invalid={
                                    productStockUpdateMutation.isError &&
                                    productStockUpdateMutation.error.response.data.name
                                }
                            />
                            {productStockUpdateMutation.isError && productStockUpdateMutation.error.response.data.name && (
                                <FormFeedback invalid>
                                    {productStockUpdateMutation.error.response.data.name}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="Stock">Stock<span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                name="stock"
                                id="stock"
                                placeholder="Stock"
                                // defaultValue={props.product.price}
                                onChange={(e) =>
                                    setProductStock(e.target.value)
                                }
                                invalid={
                                    productStockUpdateMutation.isError &&
                                    productStockUpdateMutation.error.response.data.stock
                                }
                            />
                            {productStockUpdateMutation.isError && productStockUpdateMutation.error.response.data.stock && (
                                <FormFeedback invalid>
                                    {productStockUpdateMutation.error.response.data.stock}
                                </FormFeedback>
                            )}
                        </FormGroup>
                        <FormGroup>
                            <Label for="type">Type<span className="text-danger">*</span></Label>
                            <Input
                                type="select"
                                name="select"
                                id="type"
                                className={"form-control"}
                                defaultValue={stockTransactionType}
                                onChange={(e) =>
                                    setStockTransactionType(e.target.value)
                                }
                                invalid={
                                    productStockUpdateMutation.isError &&
                                    productStockUpdateMutation.error.response.data.type
                                }
                            >
                            <option value={'CR'}>
                                CREDIT
                            </option>
                            <option value={'DR'}>
                                DEBIT
                            </option>
                            </Input>
                            {productStockUpdateMutation.isError && productStockUpdateMutation.error.response.data.type && (
                                <FormFeedback invalid>
                                    {productStockUpdateMutation.error.response.data.type}
                                </FormFeedback>
                            )}
                        </FormGroup>

                        <Button
                            color="#4d5bed"
                            className="bx-btn-primary"
                            block
                            disabled={editProductMutation.isLoading}
                        >
                            {editProductMutation.isLoading? <><Loader size={'small'}/> Updating Product...</>: `Update Stock`}

                        </Button>
                    </Form>
                </ModalBody>
            </Modal>

            {/*<Modal*/}
            {/*    isOpen={productSettingsToggle}*/}
            {/*    toggle={toggleProductSettingsModal}*/}
            {/*>*/}
            {/*    <ModalHeader toggle={toggleProductSettingsModal}>*/}
            {/*        Product Settings: {props.product.name}*/}
            {/*    </ModalHeader>*/}
            {/*              </Modal>*/}
        </td>
    );
}

export default ActionButton;